// extracted by mini-css-extract-plugin
export var acceptButton = "_22-6";
export var backdropBlur = "_22-0";
export var fullContent = "_22-5";
export var link = "_22-7";
export var linkIcon = "_22-8";
export var sideContent = "_22-4";
export var sideImage = "_22-3";
export var sideImageWrapper = "_22-2";
export var splitLayout = "_22-1";